module.exports = __webpack_public_path__ + "static/media/happy-man.56dac7c5.svg";